var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        staticClass: "bordered table-no-minheight",
        attrs: {
          items: _vm.visibleItems,
          fields: _vm.fields,
          small: "",
          "show-empty": "",
          "empty-text": _vm.$t(
            "Nenhuma linha cadastrada. Os produtos associados usam a classificação fiscal do NCM."
          ),
          responsive: "",
          striped: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(actions)",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm.canEdit
                  ? _c("e-grid-actions", {
                      attrs: { "show-update": true, "show-delete": true },
                      on: {
                        update: function ($event) {
                          return _vm.$emit("update-item", item)
                        },
                        delete: function ($event) {
                          return _vm.$emit("delete-item", item)
                        },
                      },
                    })
                  : _c("span", [_vm._v("-")]),
              ]
            },
          },
        ]),
      }),
      _c(
        "b-row",
        { staticClass: "mt-1" },
        [
          _c(
            "b-col",
            { staticClass: "text-right", attrs: { md: "12" } },
            [
              _vm.canEdit
                ? _c("e-button", {
                    attrs: {
                      variant: "primary",
                      icon: "plus-circle",
                      text: _vm.$t("Adicionar Exceção Fiscal"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("add-item")
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }